<template>
    <Overlay :show="showLoading">
        <b-row class="pb-2">
            <b-col md="6" lg="6" class="d-flex align-items-center">
                <div>
                    <h4>{{ $t('Page(ForwardRequestEmailOptions):Component(Text):page-label') }}</h4>
                </div>
            </b-col>
            <b-col md="6" lg="6">
                <div class="demo-inline-spacing float-right">
<!--                    <b-form-checkbox-->
<!--                        v-model="useAsDefault"-->
<!--                        switch-->
<!--                        class="cursor-pointer"-->
<!--                    >-->
<!--                        {{ $t('Component(Text):do-not-show-email-step') }}-->
<!--                    </b-form-checkbox>-->
                    <b-button
                        variant="primary"
                        @click="proceed"
                    >
                        {{ $t('Page(RequestEmailOptions):Component(Button):continue') }}
                    </b-button>
                    <b-button
                        variant="primary"
                        @click="goBack"
                    >
                        {{ $t('Component(Button):back') }}
                    </b-button>
                </div>

            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <RequestEmailOptions
                    @initialized="onEmailOptionsInitialized"
                    @input="onEmailOptionsChange"
                />
            </b-col>
        </b-row>
        <b-row></b-row>
    </Overlay>
</template>

<script>
import RequestEmailOptions from "@core/components/common/RequestEmailOptions";
import { BRow, BCol, BButton, BFormCheckbox } from 'bootstrap-vue'
import Overlay from "@core/components/common/Overlay";

export default {
    components: {
        RequestEmailOptions, BFormCheckbox, BRow, BCol, BButton, Overlay,
    },
    data() {
        return {
            showLoading: false,
            useAsDefault: false,
            emailOptions: {
                type: 'system',
                id: null
            },
            updateSendEmailPreferencesPromise: new Promise((resolve) => resolve())
        };
    },
    methods: {
        onEmailOptionsInitialized(type, id) {
            this.emailOptions.type = type;
            this.emailOptions.id = id;
        },
        onEmailOptionsChange(type, id) {
            this.emailOptions.type = type;
            this.emailOptions.id = id;

            const options = this.getOptions();
            this.updateSendEmailPreferencesPromise = this.$store.dispatch('updateSendEmailPreferences', {
                transport: options.et,
                configuration: options.eid ? {id: options.eid} : null
            });
        },
        getOptions() {
            const options = {
                et: this.emailOptions.type,
            };
            if (this.emailOptions.id) {
                options.eid = this.emailOptions.id;
            }
            return options;
        },
        proceed() {
            if (this.useAsDefault) {
                this.updateSendEmailPreferencesPromise
                    .then(() => {
                        return this.$store.dispatch('doNotShowSendEmailSettingsStep');
                    })
                    .then(() => {
                        this.gotoNextStep(false);
                    })
                    .catch(() => {
                        this.gotoNextStep();
                    });
            } else {
                this.gotoNextStep();
            }
        },
        gotoNextStep(withOptions = true) {
            this.$router.push({
                name: this.$route.query.n,
                params: {id: this.$route.query.nid},
                query: withOptions ? this.getOptions() : null,
            });
        },
        goBack() {
            // this.$router.push({
            //     name: this.$router.query.b,
            //     params: {id: this.$router.query.bid}
            // })
            this.$router.go(-1);
        }
    },
}
</script>
